import { useSyncExternalStore } from 'react';

/** The phone layout: at this width and below a screen shows cards instead of tables. jsdom has no `matchMedia`. */
export const PHONE_VIEW_QUERY = '(max-width: 767px)';

function watchPhone(onChange: () => void): () => void {
  if (typeof window.matchMedia !== 'function') return () => undefined;
  const query = window.matchMedia(PHONE_VIEW_QUERY);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
}

function isPhone(): boolean {
  try {
    return typeof window.matchMedia === 'function' && window.matchMedia(PHONE_VIEW_QUERY).matches;
  } catch {
    return false;
  }
}

/** Whether the viewport is a phone's, following it as it changes. */
export function usePhoneView(): boolean {
  return useSyncExternalStore(watchPhone, isPhone, () => false);
}

/** Below the two-column layout (spec §7): a list-and-detail screen stacks, and a wide table becomes cards. */
export const NARROW_VIEW_QUERY = '(max-width: 1023px)';

function watchNarrow(onChange: () => void): () => void {
  if (typeof window.matchMedia !== 'function') return () => undefined;
  const query = window.matchMedia(NARROW_VIEW_QUERY);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
}

function isNarrow(): boolean {
  try {
    return typeof window.matchMedia === 'function' && window.matchMedia(NARROW_VIEW_QUERY).matches;
  } catch {
    return false;
  }
}

/** Whether the viewport is narrower than 1024 px, following it as it changes. */
export function useNarrowView(): boolean {
  return useSyncExternalStore(watchNarrow, isNarrow, () => false);
}
